<template>
  <div>
    <el-select :placeholder="placeholder"
               ref="select"
               v-model="myselectData"
               :remote="remote"
               :filterable="remote"
               :type="type"
               :disabled="disabled"
               :companyId="companyId"
               @change="change"
               style="width:100%;">
      <el-option v-for="item in materials"
                 :key="item.id"
                 :label="item.name"
                 :value="Number(item.id)">
      </el-option>
    </el-select>
  </div>
</template>
<script>
import _constant from '@/utils/constant'
import _tax from '@/service/tax-service'
export default {
  props: {
    placeholder: {
      default: '请选择'
    },
    remote: {
      default: false
    },
    filterable: {
      default: false
    },
    type: {

    },
    companyId:"",
    disabled: null,
    index: {

    },
    selectData: {

    },
    remoteMethod: {
      
    }

  },
  data () {
    return {
      myselectData: this.selectData,
      materials: [],
      info: {
        material: ''
      },
      query: {
        state: ''
      }
    }
  },
  watch: {
    selectData (val) {
      this.myselectData = val
    }
  },

  mounted () {

    if (this.type == 'materials') {
      this.materials = _constant.materials
    } else if (this.type == 'cardType') {
      this.materials = _constant.cardType
    }  else if(this.type == 'InvoiceType'){
      var companyId={
        companyId:this.companyId
      }
      _tax.getContractCompanyInvoiceType(companyId, response => {
        this.materials = response
      }, error => {
        console.log(error)
      })} else {
      this.query.state = this.type
      _tax.selectEnum(this.query, response => {
        this.materials = response
      }, error => {
        console.log(error)
      })

    }

  },
  methods: {
    change (e) {
      this.$nextTick(() => {
        let label = this.$refs.select.selected.label
        this.$emit('change', e, label, this.type, this.index)
      })
    },
    reset(val) {
        this.myselectData=''
       
    }

  }
}
</script>